import { HorizontalTagsLayout } from 'components/partials/WorkoutTags/subcomponents/HorizontalTagsLayout'
import { WrapableTagsLayout } from 'components/partials/WorkoutTags/subcomponents/WrapableTagsLayout'
import { Box } from 'components/widgets/Box'
import React from 'react'

import { CollapsibleSection } from 'widgets/CollapsibleSection'

import programQuestions from 'utils/programQuestions.json'

import { ProgramTags } from 'types/program'
import { TagGroup } from 'types/workoutTag'

type DiscoveryTagsSectionProps = {
  programTags?: ProgramTags
  onChange: (newTags: ProgramTags) => void
}

export const DiscoveryTagsSection = ({ programTags, onChange }: DiscoveryTagsSectionProps) => {
  if (!programTags) return <></>

  const tagsData = {
    [programQuestions.data[1].id]: {
      style: 'badge',
      name: 'Program Goals',
      id: programQuestions.data[1].id,
      maxSelection: programQuestions.data[1].maxSelection,
      tags: programQuestions.data[1].values as string[],
    },

    [programQuestions.data[2].id]: {
      style: 'badge',
      name: 'Program Specifics',
      id: programQuestions.data[2].id,
      maxSelection: programQuestions.data[2].maxSelection,
      tags: programQuestions.data[2].values as string[],
    },

    [programQuestions.data[5].id]: {
      style: 'circle',
      name: 'Daily Commitment (minutes)',
      id: programQuestions.data[5].id,
      maxSelection: programQuestions.data[5].maxSelection,
      tags: programQuestions.data[5].values as string[],
    },

    [programQuestions.data[4].id]: {
      style: 'circle',
      name: 'Duration (weeks)',
      id: programQuestions.data[4].id,
      maxSelection: programQuestions.data[4].maxSelection,
      tags: programQuestions.data[4].values as string[],
    },

    [programQuestions.data[3].id]: {
      style: 'badge',
      name: 'Equipment',
      id: programQuestions.data[3].id,
      maxSelection: programQuestions.data[3].maxSelection,
      tags: programQuestions.data[3].values as string[],
    },
  }

  const selectedTagsData: ProgramTags = {
    ...programTags,
  }

  const handleChange = (id: keyof ProgramTags, index: number) => {
    const changedValue = tagsData[id].tags[index]
    const currentTags = selectedTagsData[id] as string[]

    let newTags: string[] = []
    const isRemoving = currentTags?.includes(changedValue)

    if (isRemoving) {
      if (currentTags.length <= 1) return
      newTags = currentTags.filter((t) => t !== changedValue)
    }

    if (!isRemoving) {
      const isSingleSelection = currentTags.length === 1 && tagsData[id].maxSelection === 1
      if (isSingleSelection) {
        newTags = [changedValue]
      } else {
        if (currentTags.length >= tagsData[id].maxSelection) return
        newTags = [...currentTags, changedValue]
      }
    }

    onChange({
      ...programTags,
      [id]: newTags,
    })
  }

  return (
    <CollapsibleSection
      sectionTitle='Edit Discovery Tags'
      bodyContent={
        <>
          <Box margin={{ top: 'smd' }}>
            <WrapableTagsLayout
              data={tagsData[programQuestions.data[1].id] as TagGroup}
              selectedItems={programTags.goals}
              onSelect={(index) => handleChange(tagsData.goals.id as keyof ProgramTags, index)}
            />
          </Box>

          <Box margin={{ top: 'smd' }}>
            <WrapableTagsLayout
              data={tagsData[programQuestions.data[2].id] as TagGroup}
              selectedItems={programTags.specifics}
              onSelect={(index) => handleChange(tagsData.specifics.id as keyof ProgramTags, index)}
            />
          </Box>

          <Box margin={{ top: 'smd' }}>
            <HorizontalTagsLayout
              wrapItemTitle
              data={tagsData[programQuestions.data[5].id] as TagGroup}
              selectedItems={programTags.sessionDuration}
              onSelect={(index) =>
                handleChange(tagsData.sessionDuration.id as keyof ProgramTags, index)
              }
            />
          </Box>

          <Box margin={{ top: 'smd' }}>
            <HorizontalTagsLayout
              wrapItemTitle
              data={tagsData[programQuestions.data[4].id] as TagGroup}
              selectedItems={programTags.programDuration}
              onSelect={(index) =>
                handleChange(tagsData.programDuration.id as keyof ProgramTags, index)
              }
            />
          </Box>

          <Box margin={{ top: 'smd' }}>
            <WrapableTagsLayout
              data={tagsData[programQuestions.data[3].id] as TagGroup}
              selectedItems={programTags.equipment}
              onSelect={(index) => handleChange(tagsData.equipment.id as keyof ProgramTags, index)}
            />
          </Box>
        </>
      }
    />
  )
}
